import { useState } from "react";

function Card(props) {
  const { data } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="w-full bg-white shadow-lg rounded-xl overflow-hidden transition-all duration-300 hover:shadow-xl border border-slate-200/80">
      <div className="p-6 sm:p-8">
        <h2 className="text-xl lg:text-2xl font-bold text-sky-900 leading-tight">
          {data?.title}
        </h2>
        <p className="mt-2 text-sm font-semibold text-slate-600border-slate-200">
          {data?.authors}
        </p>
        <p className="text-sm text-slate-600 border-b border-slate-200 pb-3 italic">
          {data?.position}
        </p>
        <div className="mt-4 text-slate-700">
          <div
            className={`transition-all duration-500 ease-in-out overflow-hidden ${
              isExpanded ? "max-h-[1000px]" : "max-h-20"
            }`}
          >
            <p className="text-base leading-relaxed">{data?.abstract}</p>
          </div>
          <button
            className="mt-2 text-sm font-semibold text-sky-600 hover:text-sky-800 hover:underline"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? "Show less" : "Show more..."}
          </button>
        </div>
      </div>
      <div className="bg-slate-50 px-6 sm:px-8 py-4 flex justify-end">
        <a
          className="inline-block bg-sky-600 text-white font-semibold py-2 px-5 rounded-lg shadow-sm hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-opacity-75 transition-all"
          href={data?.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          View PDF
        </a>
      </div>
    </div>
  );
}

export default Card;
